(function(angular){
	'use strict';
	
	angular.module('opportunityFundModule', [
		'apiModule',
		'coreModule',
		'countUpModule',
		'formValidationModule',
		'localStorageModule',
		'ngclipboard',
		'progressBarModule',
		'reitElementListingModule',
		'waitlistModule'
	])
	.value('globalConfig', globalConfig);

})(window.angular);